module.exports = __webpack_public_path__ + "static/media/wB.a344abb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/wB.jpg
// module id = 319
// module chunks = 2